import React, { useState } from 'react'
import styles from './PeriodPicker.module.scss'
// import { icons } from 'assets'
import { getFormattedDateRange } from './utils'
import { Props } from './PeriodPicker.types'
import cl from 'classnames'
import { SectionInput } from '../SectionInput'
import { DateRangePicker } from 'components/common'

const PeriodPicker = (props: Props) => {
  const {
    size = 'normal',
    label = 'Period',
    placeholder = 'Pick start and end date',
    period,
    setPeriod,
    className
  } = props

  const [showDatePicker, setShowDatePicker] = useState(false)

  const handleShowDatePicker: any = (v?: boolean) => {
    if (typeof v !== 'boolean') {
      v = !showDatePicker
    }
    setShowDatePicker(v)
  }

  return (
    <div className={cl(styles[size], className)}>

      <SectionInput
        className={styles.rowChild}
        label={label}
        placeholder={placeholder}
        value={getFormattedDateRange(period)}
        onClick={handleShowDatePicker}
        // icon={icons.calendar}
      />
      {/* <LabeledInput
        size={size}
        label={label}
        placeholder={placeholder}
        onClick={handleShowDatePicker}
        icon={icons.calendar}
        value={getFormattedDateRange(period)}
      /> */}
      <DateRangePicker
        visible={showDatePicker}
        setVisibility={handleShowDatePicker}
        initialValue={period}
        onSelect={setPeriod}
      />
    </div>
  )
}

export default PeriodPicker
